import { Device } from '@/Interface/Devices';
import { Component, Input, OnInit } from '@angular/core';
import { UtilityService } from '@services/utility.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-plant-devices',
  templateUrl: './plant-devices.component.html',
  styleUrls: ['./plant-devices.component.scss']
})
export class PlantDevicesComponent implements OnInit {
  isDownloading: boolean = false;
  @Input()
  set reloadDevices(value: boolean) {
    if (value) {
      this.fetchDevices();
    }
  }
  stationCode: string = ''
  isLoadingTable: boolean = false;
  devicesList: Device[] = []
  searchElement = '';
  private searchSubject: Subject<string> = new Subject();

  constructor(
    private _utilityService: UtilityService,
    private toaster: ToastrService,
  ) {
    this._utilityService.selectedProduct$.subscribe((value) => {
      this.stationCode = value;
    });
  }

  ngOnInit(): void {
    this.fetchDevices()
    this.searchSubject.pipe(debounceTime(300)).subscribe((searchTerm: string) => {
      this.searchElement = searchTerm;
      this.fetchDevices();
    });
  }

  searchData(event: Event): void {
    this.searchSubject.next((event.target as HTMLInputElement)?.value || '');
  }

  fetchDevices() {
    if (this.stationCode) {
      this.isLoadingTable = true
      this._utilityService.getDevicesData(this.stationCode, this.searchElement)
        .subscribe({
          next: (res: any) => {
            if (res && res.status === 200) {
              this.devicesList = res.data
            }
            setTimeout(() => {
              this.isLoadingTable = false;
            }, 500);
          },
          error: () => {
            this.isLoadingTable = false;
          }
        });
    }
  }
  downloadReport(): void {
    if (this.stationCode) {
      this.isDownloading = true;
      this._utilityService
        .downloadDevicesReport(this.stationCode)
        .subscribe({
          next: (res: Blob) => {
            const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = `Devices_Report_${this.stationCode}.xlsx`;
            a.click();

            window.URL.revokeObjectURL(url);
            this.isDownloading = false; // stop loader
          },
          error: () => {
            // this.resetForm();
            this.isDownloading = false; // stop loader on error
            this.toaster.error('Failed to download report. Please try again.');
          }
        });
    }
  }
}
